import React from 'react';

export default function Timeline({ events }) {
  return (
    <div className="timeline">
      {events.map((e, i) => (
        <div key={i} className="timeline-item">
          <div className="circle" />
          <div className="content">
            <span className="date">{e.date}</span>
            <h3>{e.title}</h3>
          </div>
        </div>
      ))}
    </div>
  );
}
